export default function LazyVideo(handle, {
    lazyClass,
    scrollTrigger
}) {

    let isLargeScreen = window.innerWidth >= 992;
    let hasTriggered = false;
    let observer;

    function lazyLoadVideos() {
        if (isLargeScreen && !hasTriggered) {

            const lazyVideos = document.querySelectorAll(lazyClass);
            const triggerElement = document.querySelector(scrollTrigger);

            if (!observer) {
                console.log('here');
                observer = new IntersectionObserver((entries) => {
                    entries.forEach((entry) => {
                        console.log(entry);
                        if (entry.isIntersecting && !hasTriggered) {
                            lazyVideos.forEach((video) => {
                                // Update source elements with data-src
                                const sources = video.querySelectorAll("source");
                                sources.forEach((source) => {
                                    console.log(source);
                                    source.src = source.dataset.src;
                                });
                                // Load the video after updating sources
                                video.load();
                            });
                            hasTriggered = true;
                            observer.unobserve(triggerElement);
                        }
                    });
                }, {});

            }

            observer.observe(triggerElement);
        }
    }

    lazyLoadVideos();

    window.addEventListener("resize", () => {
        isLargeScreen = window.innerWidth >= 992;
        // Re-run lazy loading if screen size changes
        lazyLoadVideos();
    });

}
